import { Pipe, PipeTransform } from "@angular/core";
import { AssetHelper } from "@app/_helpers/asset.helper";
import { AssetHistoryDocumentStatus } from '@app/_models/enums/assetHistoryDocumentStatus';
import { Asset } from '@app/_models/_DTOs/asset';
import { AssetHistory } from '@app/_models/_DTOs/assetHistory';
import { Department } from "@app/_models/_DTOs/department";
import { AssetViewModel } from '@app/_models/_viewModels/asset.viewmodel';

@Pipe({
    name: 'conflictingAssets',
    pure: false
})
export class ConflictingAssets implements PipeTransform {
    transform(value: AssetViewModel, conflictingAssets: Asset[], departments: Department[]): any {
        if(conflictingAssets != undefined && conflictingAssets.length > 0 && departments != undefined && departments.length > 0){
            let department = departments.find(
              (x) => x.id == value.departmentId
            );
            if (!department || !department.legalEntity) return false;
              return conflictingAssets.some(
                (a) =>
                  department.legalEntity.inventoryPrefix +
                    AssetHelper.GetAssetTypePrefix(value.type) +
                    value.inventoryCode ==
                  a.inventoryCode
              );
        }
        return false;
    }
}